'use client';
import Dialog from '@ui/Dialog';
import useBannerFileSelectorStore from '@/components/store/bannerFileSelectorSlice';
import React, { useState } from 'react';
import BannerForm from './BannerForm';
import useStore from 'stores/store';
import { authorizedServerFetch, revalidatePage } from 'actions/server.actions';
import { updateUserProfile } from 'stores/userActions';
import { updateNonProfitProfile } from 'stores/nonProfitAdminActions';

export default function BannerDialog() {
  const isOpen = useBannerFileSelectorStore((state) => state.open);
  const setIsOpen = useBannerFileSelectorStore((state) => state.setOpen);
  const bannerImage = useBannerFileSelectorStore((state) => state.bannerImage);
  const profileType = useBannerFileSelectorStore((state) => state.profileType);
  const user = useStore((state) => state.user.profile);

  const [saving, setSaving] = useState(false);

  const nonProfitId = user.nonProfitId;

  function closeModal() {
    // setDialogStep('form');
    setIsOpen(false);
  }

  async function onSubmit(bannerImageData, remove = false) {
    const { bannerImage } = bannerImageData;

    try {
      if (bannerImage) {
        setSaving(true);
        const formData = new FormData();
        formData.append('bannerImage', bannerImage);

        if (remove) {
          // TODO: logic to remove bannerImage
          formData.append(
            'data',
            JSON.stringify({
              bannerImage: 'delete',
            }),
          );
        }

        const type = profileType;

        switch (type) {
          case 'user': {
            const { data, ok } = await authorizedServerFetch(
              `/users/me/profile`,
              {
                method: 'PUT',
                body: formData,
              },
            );
            if (ok) {
              await updateUserProfile(data);
              revalidatePage('/profile/me');
            }
            break;
          }
          case 'npo': {
            const { data, ok } = await authorizedServerFetch(
              `/npo-admin/organization/profile`,
              {
                method: 'PUT',
                body: formData,
              },
            );
            if (ok) {
              await updateNonProfitProfile(data, nonProfitId);
              revalidatePage('/organization/[slug]');
            }
            break;
          }
          case 'company': {
            revalidatePage('/company/[slug]');
            break;
          }
          default:
            console.log('no type found');
            break;
        }
      }
    } catch (err) {
      console.log('errr', err);
    } finally {
      setSaving(false);
    }

    closeModal();
  }

  const handleDeleteBanner = () => {
    // TODO: to make the banner image field null and remove the original banner
    onSubmit(
      {
        bannerImage: {},
      },
      true,
    );
  };

  return (
    <div>
      <Dialog isOpen={isOpen} onClose={closeModal} maxWidth="lg">
        {/* {dialogStep === 'form' && ( */}
        <div className="flex w-full gap-24 py-6 lg:py-0">
          <BannerForm
            bannerImage={bannerImage}
            deleteBanner={handleDeleteBanner}
            onSubmit={onSubmit}
            saving={saving}
          />
        </div>
        {/* )} */}
        {/* {dialogStep === 'success' && (
          <div className="flex flex-col gap-8 flex-1 items-center justify-center">
            <Typography variant="h1">Thank You!</Typography>
            <Typography variant="h5">Your Banner image is updated.</Typography>
          </div>
        )} */}
      </Dialog>
    </div>
  );
}
